// GuestFoodOrder.js

import React, {
    useEffect,
    useState,
} from "react";

import {
    useNavigate,
    useParams,
} from "react-router-dom";

import axios from "../../../utills/api";

import {
    Container,
    Card,
    CardBody,
    Button,
    Spinner,
    Nav,
} from "reactstrap";

import {
    RiArrowLeftLine,
} from "react-icons/ri";

import FoodOrder from "./FoodOrder";


const GuestFoodOrder = () => {
    const navigate = useNavigate();
    const { roomNumber, tenantId } = useParams();
    const [booking, setBooking] =
        useState(null);
    const [loading, setLoading] =
        useState(true);

  useEffect(() => {
    loadGuestBooking();
}, [tenantId, roomNumber]);

    const loadGuestBooking = async () => {
  try {
    const { data } = await axios.get(
      "/bookings/guest-room",
      {
        params: {
          tenantId,
          roomNumber,
        },
      }
    );

    setBooking(data);
  } catch (error) {
    console.error(
      "Booking loading error:",
      error
    );
  } finally {
    setLoading(false);
  }
};

    if (loading) {

        return (

            <div className="text-center mt-5">

                <Spinner />

                <div className="mt-2">
                    Loading Guest Details...
                </div>

            </div>
        );
    }

    if (!booking) {

        return (

            <Container className="mt-5">
                <Card>
                    <CardBody className="text-center">

                        <h5>
                            Booking not found
                        </h5>

                        <Button
                            color="primary"
                            onClick={() =>
                                navigate(-1)
                            }
                        >
                            Go Back
                        </Button>

                    </CardBody>

                </Card>

            </Container>

        );

    }
   return (

    <div className="guestServicePage">

        {/* HEADER NAVBAR */}

        <div
            className="guestServiceHeader d-flex align-items-center px-3"
            style={{
                width: "100%",
                height: "70px",
                background: "#ffffff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                position: "sticky",
                top: 0,
                zIndex: 1000
            }}
        >

            <Button
                color="light"
                className="me-3 d-flex align-items-center justify-content-center"
                style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%"
                }}
                onClick={() =>
                    navigate(-1)
                }
            >
                <RiArrowLeftLine
                    size={22}
                />

            </Button>
            <div>
                <h4 className="mb-0">
                    Food Order
                </h4>
                <small className="text-muted">

                    Room :
                    {" "}
                    {
                        booking.assignedRoom
                            ?.roomNumber
                    }

                </small>
            </div>
        </div>
        {/* PAGE CONTENT */}

        <Container
            fluid
            className="pt-3"
        >
            <Card
                className="border-0 shadow-sm"
            >
                <CardBody>
                    <FoodOrder

                        booking={
                            booking
                        }

                    />
                </CardBody>
            </Card>
        </Container>
    </div>

);
};

export default GuestFoodOrder;